<template>
  <div @mouseup="if (closeYn) goHome();">
    <div class="process">
      <div class="toast-box">{{ $t('User.MobileFinish.msg1') }}</div>
    </div>

    <!-- 아래 요소 높이 일정해야 함 -->
    <div class="payment__content">
      <!-- header -->
      <div class="layer__header" v-if="orderType != 'F'">
        <div class="lyr-title">{{ $t('User.MobileFinish.msg2') }}</div>
        <div class="ft-point">{{ $t('User.MobileFinish.msg3') }}</div>
        <!-- <div class="lyr-txt">입력하신 번호는 별도 인증을 진행하지 않습니다</div> -->
      </div>
      <div class="layer__header" v-else>
        <div class="lyr-title">{{ $t('User.WineFinish.msg1') }}</div>
        <div class="ft-point">{{ $t('User.WineFinish.msg2') }}</div>
        <!-- <div class="lyr-txt">입력하신 번호는 별도 인증을 진행하지 않습니다</div> -->
      </div>
      <!-- //header -->

      <div class="payment__body">
        <div class="center"><img :src="mobileLogoSrc" alt="" /></div>
        <div class="center"><img :src="receiptSrc" alt="" /></div>
        <span class="info-txt ft-point" v-if="!closeYn">{{ $t('User.MobileFinish.msg5') }}</span>
        <span class="ft--lg center">{{ $t('User.MobileFinish.msg6') }}</span>
        <div class="sub-txt" v-if="closeYn">
          <em>{{ num }}</em
          ><span>{{ $t('User.Pickup.PickupFinish.msg4') }}</span>
        </div>
      </div>

      <div class="layer__button">
        <button class="btn btn--half btn--cancel btn-anim" :disabled="printYn == 'Y' || closeYn" @mouseup="setPrint('N')">
          {{ $t('User.MobileFinish.msg8') }}
        </button>
        <button class="btn btn--half btn--submit btn-anim" :disabled="printYn == 'N' || closeYn" @mouseup="setPrint('Y')">
          {{ $t('User.MobileFinish.msg7') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import audioHelper from '@/js/common/audioHelper.js';

export default {
  name: 'mobileFinish',
  props: {
    tranObj: Object,
  },
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
      num: 5,
      closeYn: false,
      printYn: '',
      timer: null,
      intval: null,
      receiptSrc: null,
      mobileLogoSrc: null,
      orderType: this.$store.getters.getPosConfig.posConfig.templateNo,
    };
  },
  mounted() {
    if (this.$i18n.locale == 'jp') {
      this.receiptSrc = require('@/assets/images/user/artwork_popup_receipt_3d_jp.gif');
    } else if (this.$i18n.locale == 'ko') {
      this.receiptSrc = require('@/assets/images/user/artwork_popup_receipt_3d_ko.gif');
    } else if (this.$i18n.locale == 'en') {
      this.receiptSrc = require('@/assets/images/user/artwork_popup_receipt_3d_en.gif');
    } else if (this.$i18n.locale == 'cn') {
      this.receiptSrc = require('@/assets/images/user/artwork_popup_receipt_3d_zh_cn.gif');
    } else if (this.$i18n.locale == 'tw') {
      this.receiptSrc = require('@/assets/images/user/artwork_popup_receipt_3d_zh_tw.gif');
    }

    if(this.orderType == 'F') {
      this.mobileLogoSrc = require('@/assets/images/user/img_character.png');
    } else {
      if (this.$store.getters.getIsSimpleToken === true) {
        this.mobileLogoSrc = require('@/assets/images/user/img-info-line02.png');
      } else {
        this.mobileLogoSrc = require('@/assets/images/user/img-info-kakaotalk.png');
      }
    }

    try {
      //this.audio.play(); // 20230406 HSSHIN Audio 재생

      audioHelper.playAudio('00202', this.$i18n.locale, this.$store.getters.getPosConfig.posConfig.useVoiceSupport);
    } catch (ex) {
      console.error(ex);
    }
  },
  unmounted() {
    try {
      //this.audio.pause(); // 20230406 HSSHIN Audio 중지
      audioHelper.stopAudio();
    } catch (ex) {
      console.error(ex);
    }
  },
  components: {},
  methods: {
    goHome() {
      clearTimeout(this.timer);
      clearInterval(this.intval);
      this.$router.replace('/user/idle');
    },
    async setPrint(yn) {
      this.$logInfo(`Print YN : ${yn}`);
      try {
        this.closeYn = true;
        this.intval = setInterval(() => {
          this.num--;
        }, 1000);
        this.timer = setTimeout(() => {
          this.$router.replace('/user/idle');
        }, 5000);
      } catch (e) {
        this.$logInfo(`Print Error : ${e}`);
      }
    },
  },
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/pages/payment.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/dark/payment-dark.css" scoped></style>
<style scoped>
.payment__content,
.dark .payment__content {
  width: 100%;
}

.info-box,
.dark .info-box {
  width: auto;
}

.layer__button,
.dark .layer__button {
  width: 100%;
  left: 0;
  justify-content: center;
}

.layer__button button,
.dark .layer__button button {
  width: 37%;
}

.layer__button button + button,
.dark .layer__button button + button,
.btn-bottom-fix .btn--line + .btn--line,
.dark .btn-bottom-fix .btn--line + .btn--line {
  margin-left: 2.3vw;
}
</style>
